import { addDays, addMonths, addWeeks, addYears, format } from 'date-fns';

import { BillingPeriod, Plan } from '../types';
import { isStrictNever } from './isStrictNever';

/**
 * This is related to the philosophical issue that during signup membership is not actually started until the
 * activation. So Supa has nothing to calculate the dates from and the plans array arrives with null in
 * startDate/endDate of each plan.
 *
 * BUT, because people want to see dates - we need to guess them with the assumption that activation will be done at the
 * given date.
 *
 * Note: The pland are in chronological order and they have clear periodLength and periodType values so the calculation
 * is quite straightforward.
 */
export const calculatePlanDatesIfActivatedOn = (plans: Plan[], activationDate: Date) => {
  // Start the first plan from the activation date
  let startDate = activationDate;

  return plans.map((plan) => {
    // If dates are already provided, use them
    if (plan.startDate && plan.endDate) {
      // Update startDate for the next plan to start where this one ends
      startDate = new Date(plan.endDate);
      return plan;
    }

    const currentStartDate = startDate;
    let endDate;

    // TODO: MMBER-10558 - Pending activation trial plan does not show period length correctly
    const periodLength = Math.max(plan.periodLength, 1);

    switch (plan.periodType) {
      case BillingPeriod.Days:
        endDate = addDays(currentStartDate, periodLength);
        break;
      case BillingPeriod.Weeks:
        endDate = addWeeks(currentStartDate, periodLength);
        break;
      case BillingPeriod.Months:
        endDate = addMonths(currentStartDate, periodLength);
        break;
      case BillingPeriod.Years:
        endDate = addYears(currentStartDate, periodLength);
        break;
      default:
        isStrictNever(plan.periodType);
    }

    // Update startDate for the next plan to start where this one ends
    startDate = endDate;

    return {
      ...plan,
      startDate: format(currentStartDate, 'yyyy-MM-dd'),
      endDate: format(endDate, 'yyyy-MM-dd'),
    } satisfies Plan;
  });
};
